<script>
  import Caret from "../icons/Caret.svelte";
  export let id;
  export let title;
  export let collapseable = false;
  export let dataTestId = "";

  const hasHeader = title || collapseable;
</script>

<style>
  .search-wrap {
    margin-bottom: 1rem;
    padding: 1rem;
  }

  header {
    align-items: center;
    border-bottom: 1px solid var(--gray-second);
    display: flex;
    padding-bottom: 0.5rem;
    margin-bottom: 0.5rem;
  }

  h3 {
    font-weight: 600;
    margin: 0;
    margin-left: 0.5rem;
  }

  /* Sadly CSS variables do not support media queries */
  @media screen and (max-width: 768px) {
    .search-wrap {
      margin-left: 0;
      margin-bottom: 1rem;
    }
  }
</style>

<div {id} data-testid={dataTestId} class="search-wrap">
  {#if hasHeader}
    <header>
      {#if collapseable}
        <Caret />
      {/if}
      {#if title}
        <h3>{title}</h3>
      {/if}
    </header>
  {/if}
  <slot />
</div>
